export const storageKey = {
  TOKEN: "nmu-token",
  CHAT_TOKEN: "chat-token",
};

export const fileTYPE_IMG = "image/png, image/jpeg, image/jpg, image/gif";

// , text/plain
export const fileTYPE_DOCUMENT =
  ".doc,.docx, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/pdf";
export const fileTYPE_VIDEO =
  "video/mp4, video/mpeg, video/x-msvideo, video/x-flv, video/x-ms-wmp, video/x-ms-wmv, video/x-ms-wmx";

export const groupType = {
  NEWS: 2,
  ACTIVITY: 1,
  BANNER: 0,
  NOTIFICATION: 3,
  SERVICE_LINK: 4,
  TEMPLATE: 5,
  HIGHLIGHT_BOX: 6,
  CONTENT: -1,
  FOOTER_LINK: 7
};

export const formatDateTime = {
  DDMMYYYY_SLASH: "DD/MM/YYYY",
  DDMMMYYYY_SPACE: "DD MMM YYYY",
  FULLDATETIME: "DD/MM/YYYY HH:mm:ss",
  HOURMINUTE: "HH:mm",
};

export const galleryType = {
  VIDEO: 0,
  PHOTO: 1,
  DOCUMENT: 2,
};

export const PREVIEW_TYPE = {
  banner: "banner",
  activity: "activity",
  news: "news",
  notification: "notification",
  serviceLink: "serviceLink",
  footerLink: "footerLink",
  highlightBox: "highlightBox",
  mainContent: "mainContent",
  content: "content",
};

export const chatConnectStatus = {
  NONE: "NONE",
  CONNECTING: "CONNECTING",
  CONNECTED: "CONNECTED",
  SUBSCRIBED: "SUBSCRIBED",
  DISCONNECTED: "DISCONNECTED",
  FAIL: "FAIL",
};

export const DEFAULT_SORT_CONFIG = {
  numeric: true,
  sensitivity: "accent", // non-sensitive
  ignorePunctuation: true,
};

export const COMMON = {
  RAW_DATA: "rawData",
  WARN_FIELD: "warningFields",
  ERROR_FIELD: "errorFields",
  SALT: "AyDpoYG559nzIqNR",
  SALT_INDEX: 15,
  NOTIFICATION_TIMING: 5,
  REM_UP: "remUP",
  TEMPLATE_MARGIN: "160px",
  PAGING_BOTTOM_MARGIN: "24px",
};
